import { createSlice } from "@reduxjs/toolkit";

import { parseUA } from "~/tools/common";
import { StoreCommon } from "~/types/index";
import { useAppSelector } from ".";
import { isEqual } from "lodash-es";

const initialState: StoreCommon.CommonState = {} as StoreCommon.CommonState;

export const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
        //更新用户信息
        UPDATE_USER: (state, action) => {
            state.user = action.payload;
        },
    },
});

export const { UPDATE_USER } = commonSlice.actions;

export default commonSlice.reducer;

export const useCommonState = () => {
    const constValue = useAppSelector(
        (state) => {
            const stateCommon = state.common;
            const { lp, initData } = stateCommon;

            return {
                lp,
                initData,
                isIos: lp
                    ? lp?.platform === "ios" || lp?.platform === "macos"
                    : parseUA()?.ios,
                platform: lp?.platform,
                isIphone: lp ? lp?.platform === "ios" : parseUA()?.ios,
                user: stateCommon.user,
            };
        },
        { equalityFn: isEqual }
    );

    return constValue;
};
